import CUSTOM_CERT_TYPES from './_actionTypes';

export const uploadExcelRequest = (file) => ({
  type: CUSTOM_CERT_TYPES.UPLOAD_EXCEL_REQUEST,
  payload: { file },
});

export const uploadExcelSuccess = (job) => ({
  type: CUSTOM_CERT_TYPES.UPLOAD_EXCEL_SUCCESS,
  payload: job,
});

export const uploadExcelFailure = (error) => ({
  type: CUSTOM_CERT_TYPES.UPLOAD_EXCEL_FAILURE,
  payload: { error },
});

export const fetchJobStatusRequest = (jobId) => ({
  type: CUSTOM_CERT_TYPES.FETCH_JOB_STATUS_REQUEST,
  payload: { jobId },
});

export const fetchJobStatusSuccess = (job) => ({
  type: CUSTOM_CERT_TYPES.FETCH_JOB_STATUS_SUCCESS,
  payload: job,
});

export const fetchJobStatusFailure = (error) => ({
  type: CUSTOM_CERT_TYPES.FETCH_JOB_STATUS_FAILURE,
  payload: { error },
});

export const fetchJobsListRequest = () => ({
  type: CUSTOM_CERT_TYPES.FETCH_JOBS_LIST_REQUEST,
});

export const fetchJobsListSuccess = (jobs) => ({
  type: CUSTOM_CERT_TYPES.FETCH_JOBS_LIST_SUCCESS,
  payload: jobs,
});

export const fetchJobsListFailure = (error) => ({
  type: CUSTOM_CERT_TYPES.FETCH_JOBS_LIST_FAILURE,
  payload: { error },
});

export const clearCurrentJob = () => ({
  type: CUSTOM_CERT_TYPES.CLEAR_CURRENT_JOB,
});
